import React from 'react';
import '../../assets/css/switch.css';

const CustomSwitch = ({ id, disabled, checked, onChange }) => (
  <label className="custom-switch">
    <input
      type="checkbox"
      id={id}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
    />
    <span className={`slider ${checked ? 'checked' : ''}`}></span>
  </label>
);

export default CustomSwitch;
